import React from 'react';
import {connect} from 'react-redux';

import TCSPopularDestinationsDataLoader from './TCSPopularDestinationsDataLoader';
import PopularDestinations from './PopularDestinations';

export const PopularDestinationsComponent = (props) => {
    let popularDestinations;
    if (props.allowTopDestinationsTcs) {
        popularDestinations = <TCSPopularDestinationsDataLoader {...props} />;
    } else {
        popularDestinations = <PopularDestinations {...props} />;
    }

    return (
        <div className="popular-destinations-wrapper">
            {popularDestinations}
        </div>
    );
};

export const mapStateToProps = ({
    config: {isMobile},
    modules: {popularDestinations},
    options: {showMapComponent, allowTopDestinationsTcs},
}) => {
    return {
        isMobile,
        ...popularDestinations,
        showMapComponent,
        allowTopDestinationsTcs,
    };
};

const MLPPopularDestinations = connect(mapStateToProps)(
    PopularDestinationsComponent
);

MLPPopularDestinations.displayName = 'MLPPopularDestinations';

export default MLPPopularDestinations;
